import Actions from 'redux/actions'
import type { CallAPIAction, Status } from 'api/types'
import { CancelContractAuthRequestFailResponse, CancelContractAuthRequestResponse } from 'api/contractAuthAPI'

type State = {
  errorMessage: string
} & Status

const initialState: State = {
  errorMessage: '',
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.CANCEL_CONTRACT_AUTH_APPENDIX_ASYNC,
    Actions.CANCEL_CONTRACT_AUTH_APPENDIX_SUCCESS,
    Actions.CANCEL_CONTRACT_AUTH_APPENDIX_FAIL,
    CancelContractAuthRequestResponse,
    CancelContractAuthRequestFailResponse
  >,
): State => {
  switch (action.type) {
    case Actions.CANCEL_CONTRACT_AUTH_APPENDIX_ASYNC:
    case Actions.CANCEL_CONTRACT_AUTH_APPENDIX_SUCCESS: {
      return {
        ...state,
        ...action.status,
        errorMessage: '',
      }
    }
    case Actions.CANCEL_CONTRACT_AUTH_APPENDIX_FAIL: {
      return {
        ...state,
        ...action.status,
        errorMessage: action.payload?.error?.message || '',
      }
    }
    default:
      return state
  }
}
